import React from 'react';
import Layout from '../components/Layout';
import { Seo } from '../components/Seo';
import Terms from '../components/Terms';
import OpenGraph from '../images/open-graph.png';
import { graphql } from 'gatsby';
import { PrismicRichText } from '@prismicio/react';

const PrivacyPolicy = ({ data }) => {
  const policy = data.prismicPrivacyPolicy.data;
  return (
    <Layout>
      <Terms>
        <PrismicRichText
          field={policy.privacy_policy.richText}
          components={{
            paragraph: ({ children }) => <p className="body-m-regular">{children}</p>,
          }}
        />
      </Terms>
    </Layout>
  );
};

export default PrivacyPolicy;

export const Head = ({ data }) => (
  <Seo title={data.prismicMetadata.data.title.text}>
    <meta name="description" content={data.prismicMetadata.data.description.text} />
    <meta property="og:title" content={data.prismicMetadata.data.title.text} />
    <meta property="og:image" content={OpenGraph} />
    <meta property="og:image:width" content="1200" />
    <meta property="og:image:height" content="630" />
    <meta property="og:type" content="website" />
  </Seo>
);

export const PrivacyPolicyQuery = graphql`
  query {
    prismicPrivacyPolicy(data: { privacy_policy: { richText: {} } }) {
      id
      data {
        privacy_policy {
          richText
        }
      }
    }
    prismicMetadata(data: { page: { text: { eq: "privacy-policy" } } }) {
      data {
        title {
          text
        }
        description {
          text
        }
      }
    }
  }
`;
